// Layout: Browse Talent Groups
// 

JLM.MD.TalentBrowseGroups = function( container, division_type ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let talent_filter, talent_wrap, search_message;
	
	// Settings
	let categories_by_id = {},
		categories_by_talent_id = {};
	
	// Data
	let data_categories;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Data
		data_categories = JLM.database.getTalentList( division_type );
		let data_talent = [];
		
		// Set references
		talent_wrap = $('section .wrap', container);
		// search_message = $('<div class="message">No talent matches…</div>');
		
		// Create groups
		$('.category', talent_wrap).each(function() {
			// References
			const category_ref = $(this),
				  category_id = category_ref.attr('data-category-id'),
				  group = new JLM.MD.TalentBrowseGroup( category_ref, division_type, data_categories[ category_id ].talent );
			categories_by_id[ category_id ] = group;
			
			// Events
			group.on('toggle', function() {
				for( let id in categories_by_id ) {
					categories_by_id[ id ].recalculate();
				}
			});
			group.on('shortlist_remove', function() {
				INSTANCE.dispatchEvent('shortlist_remove', [].slice.call( arguments ));
			});
			group.on('shortlist_add', function() {
				INSTANCE.dispatchEvent('shortlist_add', [].slice.call( arguments ));
			});
			
			// Save talent data
			data_categories[ category_id ].talent.forEach(function( entry ) {
				categories_by_talent_id[ entry.ID ] = group;
				data_talent.push( entry );
			});
		});
		
		// Filter
		if ( division_type == JLM.NS.DIVISION_CONTENT_CREATORS ) {
			talent_filter = new JLM.MD.TalentBrowseFilterContentCreators( $('> aside', container), data_talent );
		} else if ( division_type == JLM.NS.DIVISION_BRAND_AMBASSADORS ) {
			talent_filter = new JLM.MD.TalentBrowseFilterBrandAmbassadors( $('> aside', container), data_talent );
		}
		
		// Events
		talent_filter.on('change', filter);
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Filter groups
	// 
	function filter( data_match, name_search ) {
		var num_matches = 0;
		
		// Update each category group
		for( let id in categories_by_id ) {
			num_matches += categories_by_id[ id ].filter( data_match, name_search );
		}
		
		// Show message if no results
		// if ( num_matches == 0 ) {
		//	search_message.appendTo( talent_wrap );
		// } else {
		//	search_message.remove();
		// }
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Remove entries from Shortlist
	// 
	INSTANCE.removeFromShortlist = function( talent_id, division_type ) {
		for( let id in categories_by_id ) {
			categories_by_id[ id ].removeFromShortlist( talent_id, division_type );
		}
	};
	INSTANCE.emptyShortlist = function() {
		for( let id in categories_by_id ) {
			categories_by_id[ id ].emptyShortlist();
		}
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};